module.exports = __webpack_public_path__ + "static/realstar-logo-50df3ee424fa1e2789104d73d5463718.jpg";